import Templates from './templates-container';

export default Templates;
